// extracted by mini-css-extract-plugin
module.exports = {"floatingChatBubble":"FloatingChatBubble--floating-chat-bubble--2Xh6K"};